
export enum ParentActivityTypeCd {
	DOCK_ACTIVITY = 'DockActivity',
	TRIP_ACTIVITY = 'TripActivity'}

